import TextToolTip from './TextToolTip';

export default TextToolTip;
